import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;



export const fetchStatesData = createAsyncThunk('fetchStatesData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getStatelist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleStates = createAsyncThunk('fetchSingleStates', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getStatelist&stateId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});



const statesSlice = createSlice({
    name: 'StatesData',
    initialState: {
        isLoading: false,
        states: null,
        singleState: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchStatesData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStatesData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.states = action.payload;
        });
        builder.addCase(fetchStatesData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        

        builder.addCase(fetchSingleStates.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleStates.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleState = action.payload;
        });
        builder.addCase(fetchSingleStates.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });




    }
});

export default statesSlice.reducer;
